(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Select all Instagram image containers in this specific section that have a URL.
  const instaImages = document.querySelectorAll('.insta-image[data-dblclick-url]')
;

  instaImages.forEach(image => {
    // We use a 'click' listener to handle both desktop double-clicks and mobile double-taps.
    // Each image gets its own 'lastTap' variable to track time between clicks.
    let lastTap = 0;
    
    image.addEventListener('click', function(event) {
      const currentTime = new Date().getTime();
      const tapLength = currentTime - lastTap;

      // If the time between two taps is less than 400ms, treat it as a double tap.
      if (tapLength < 1200 && tapLength > 0) {
        const url = this.dataset.dblclickUrl;
        // Ensure there's a URL before redirecting.
        if (url) {
          window.location.href = url;
        }
      }
      
      // Update the lastTap time for the next click.
      lastTap = currentTime;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
